import React from 'react';
import classNames from 'classnames';

function resolveImageSrc(src) {
  if (!src) return '';
  return src.startsWith('/') ? src : `/${src}`;
}

export default function ExpertiseImage({ item, alt, variant = 'default' }) {
  const photoSrc = item.photo || item.image;
  const src = resolveImageSrc(photoSrc);
  const webp = item.imageWebp ? resolveImageSrc(item.imageWebp) : null;
  const isLargePhoto = variant === 'hero' || variant === 'inline';
  const imgClass = classNames('rounded-3', {
    'jassp-expertise-detail-img': variant === 'default',
    'jassp-expertise-detail-img--hero': isLargePhoto,
  });

  if (webp && variant === 'default') {
    return (
      <picture>
        <source type="image/webp" srcSet={webp} />
        <img src={src} className={imgClass} alt={alt} loading="lazy" decoding="async" />
      </picture>
    );
  }

  return (
    <img
      src={src}
      className={imgClass}
      alt={alt}
      loading={isLargePhoto ? 'eager' : 'lazy'}
      decoding="async"
    />
  );
}
